// Re-export all individual users and arrays from issue type files
// Import environment-specific arrays for combining
import { devAuditOnPlatformTestUsers } from './audit-on-platform-test-users';
import { devInternalControlsTestUsers } from './internal-controls-test-users';
import {
  devIssueManagerTestUsers,
  localIssueManagerTestUsers,
} from './issue-manager-test-users';
import { devRiskManagerTestUsers } from './risk-manager-test-users';

export * from './audit-on-platform-test-users';
export * from './internal-controls-test-users';
export * from './issue-manager-test-users';
export * from './risk-manager-test-users';
export * from './types';

// Environment-specific combined arrays for seeders
export const localTestUsers = localIssueManagerTestUsers;

export const devTestUsers = [
  ...devIssueManagerTestUsers,
  ...devAuditOnPlatformTestUsers,
  ...devRiskManagerTestUsers,
  ...devInternalControlsTestUsers,
];
